import AppInfo from "./helpers/appInfo";

const dev = {
  env: "dev",
  label: "Development",
  logger: true,
};

const test = {
  env: "test",
  label: "Test",
  logger: true,
};

const prod = {
  env: "prod",
  label: "Staging",
  logger: false,
};

const apis = {
  auth: {
    login: "/api/Account/Login", // POST
    loginAua: "/api/Account/LoginAua", // POST
    logout: "/v1/auth/logout", // POST
    me: "/api/Account/User", // GET
    landingPageAperta: "/api/Account/User/LandingPageAperta", // POST
    myAgency: "/api/Account/Agencies",
    refreshToken: "/v1/auth/refreshToken", // POST,
    sendResetPassword: "/api/Account/SendResetPassword",
    resetPassword: "/api/Account/ResetPassword",
    newToken: "/api/Account/token",
    createCustomerAccount: "/api/User/new-customer"
  },
  userConsent: {
    checkForContract: "/api/UserConsent/by-c/:contractId",
    create: "/api/UserConsent",
  },
  admin: {},
  customers: {
    agency: "/api/Agency", // GET
    businessType: "/api/Agency/BusinessTypes",
    approveContract: "api/Agency/:agencyId/Contracts/:contractId",
    editEconomicDetails:
      "/api/Agency/:agencyId/Contracts/:contractId/economics",
    recalculateEconomicDetails:
      "/api/Agency/:agencyId/Contracts/:contractId/economics/recalculate",
  },
  contractProduct: {
    list: "/api/ContractProduct/contract/:contractId",
    update: "/api/ContractProduct/:contractProductId",
  },
  products: {
    families: "/api/Anagra/ProductFamilies",
    familyLogo: "/api/Anagra/ProductFamilies/:familyId/logo?agencyId=:agencyId",
    familyImage: "/api/Anagra/ProductFamilies/:familyId/image",
    familyDefaultLogo: "/api/Anagra/ProductFamilies/:familyId/logo",
    duration: "/api/Anagra/FinancialDurations",
    list: "/api/Agency/:agencyId/Products",
    accessories:
      "/api/Agency/:agencyId/ProductModel/:productModelId/Accessories",
    services: "/api/Agency/:agencyId/ProductModel/:productModelId/Services",
    createContract: "/api/Agency/:agencyId/Contracts",
    approveContract:
      "/api/Agency/:agencyId/Contracts/:contractId/Grenke/CancelDossier",
    prices: "/api/Agency/:agencyId/Contracts/prices",
    taxSavings: "/api/Agency/:agencyId/Contracts/tax-savings",
    personalizedProductPrice: "/api/Agency/:agencyId/GetPersonalizedProductPrice",
    catalog: "/api/Agency/:agencyId/CatalogXLS",
  },
  import: {
    importXLS: "/api/Import/XLS/",
    importXLSMultipleAgency: "/api/Import/XLS-multiple/",
    agencies: "/api/Agency",
    exportXLS: "/api/Agency/:agencyId/ContractsXLS",
    getImportUserTemplate: "/api/Import/XLS/ImportUserTemplate",
  },
  export: {
    productPriceList: "/api/Export/ProductPriceListXLS/:agencyId",
    master: "/api/Export/MasterXLS",
    margins: "/api/Export/MarginsXLS/:agencyId",
    contractProductsEconomics: "/api/Export/ContractProductsEconomics/:contractId",
    provvigioneBeneficiari: "/api/Export/ProvvigioneBeneficiariXLS",
    users: "/api/Export/UsersXLS",
    userLoggins: "/api/Export/UserLogginsXLS",
    userConsents: "/api/Export/UserConsentsXLS",
    ifisCoefficients: "/api/Export/IfisCoefficientsXLS",
  },
  creditSafe: "https://connect.creditsafe.com/v1",
  creditSafeVatNo: "https://connect.creditsafe.com/v1/companies?countries=IT",
  // creditSafeName: "https://connect.creditsafe.com/v1/people?page=1&pageSize=10&countries=IT",
  creditSafeFinancial: "https://connect.creditsafe.com/v1/companies",
  users: {
    user: "/api/User",
    agencies: "/api/Agency",
  },
  icecat: {
    internal: "/api/s3",
    completeInfo:
      "https://live.icecat.biz/api?shopname=openicecat-live&lang=IT&UserName=gciardo:codiceGTIN&app_key=yJc7YMhJ1B-8J27O_I3cXUuPkNpkVar3",
    content: "/api/Icecat",
    gallery: "/api/Icecat/gallery",
  },
  smartComSystem: "/api/smartComSystem",
  privacyFile: "/api/smartComSystem/PrivacyFile",
  agencies: {
    agency: "/api/Agency",
    signers: "/api/Agency/SignersList",
    logo: "/api/Agency/:agencyId/logo",
    recalculateAllPrices: "/api/Agency/recalculate-prices",
    onboardingConfig: "/api/Agency/onboarding-config/:agente",
    onboardingLogo: "/api/Agency/onboarding-logo/:agente",
    onboardingDiscount: "/api/Agency/onboarding-discount",
  },
  orders: {
    list: "/api/Agency/:agencyId/Orders",
    export: "/api/Agency/contracts-orders",
    exportSerials: "/api/Agency/contracts-serials",
  },
  tickets: {
    list: "/api/Ticket",
    save: "/api/Ticket",
    saveEstendo: "/api/Ticket/Estendo",
    delete: "/api/Ticket/:id",
    estendoQuestions: "/api/Ticket/estendo-questions/:contractProductId"
  },
  chat: {
    message: "/api/Chat/message",
    logs: "/api/Chat/logs",
  },
  stats: {
    stats: "/api/Statistics",
  },
  accessories: {
    charges: "/api/OneriAccessori",
  },
  virtualLand: {
    stories: '/api/VirtualLand/stories'
  },
  creditProviders: {
    list: "/api/CreditProviders",
  },
  commissions: {
    reportFatturazione: "/api/Commission/report-fatturazione",
    dettaglio: "/api/Commission/dettaglio",
    presentazioni: "/api/Commission/presentazioni",
    riepilogoAnnuale: "/api/Commission/riepilogo-annuale",
    riepilogoCompleto: "/api/Commission/riepilogo-completo",
    recalculateAllProvvigioni: "/api/Commission/calcola-provvigioni",
    recalculateProvvigioniByAgencyId: "/api/Commission/ricalcola-provvigioni",
  },
  serviziAgenzia: {
    voci: "/api/ServiziAgenzia/voci",
    vociXls: "/api/ServiziAgenzia/voci/xls",
    fatture: "/api/ServiziAgenzia/fatture",
    scollegaVoce: "/api/ServiziAgenzia/voci/:id/fattura",
    riepilogoAgenzie: "/api/ServiziAgenzia/riepilogo-agenzie",
    datiFatturazione: "/api/ServiziAgenzia/dati-fatturazione",
  },
  aliquoteContributive: {
    list: "/api/AliquoteContributive",
    detail: "/api/AliquoteContributive/:id",
  },
  regoleProvvigionali: {
    list: "/api/RegoleProvvigionali",
    detail: "/api/RegoleProvvigionali/:id",
  },
};

const env_config = function () {
  switch (AppInfo.env) {
    case "production":
      return prod;
    case "test":
      return test;
    case "development":
      return dev;
    default:
      return dev;
  }
};

const publicConfig: {
  start: string;
  env: string;
  label: string;
  logger: boolean;
  apiBaseurl: string;
  appBaseurl: string;
  defaultLocale: string;
  forceLocale?: string;
  enableLocales?: string[];
  localeCookieName: string;
  localeDictUrl?: string;
  firebaseConfig?: object;
} & {
  [x: string]: string | number | boolean | Date | JSON | JSON[];
} & typeof Config = {
  start: new Date().toISOString(),
  env: "dev",
  label: "Development",
  logger: false,
  defaultLocale: "it",
  localeCookieName: "locale",
  ...(window as any).config,
};

const Config = {
  app_name: AppInfo.name,
  app_version: AppInfo.version,
  maintenance_mode: false,
  /** Host del dominio deprecato: mostra la pagina di reindirizzamento */
  legacyAppHostname: "app.smartcomsolutions.it",
  /** Host e origin del nuovo indirizzo dell'applicazione */
  newAppHostname: "app.noleggiosumisura.it",
  newAppOrigin: "https://app.noleggiosumisura.it",

  roleScopes: {
    SUPERADMINISTRATOR: {
      anagManagement: ["create", "read", "update", "delete", "any"],
      products: ["create", "read", "update", "delete", "any"],
      customers: ["create", "read", "update", "delete", "any"],
      families: ["create", "read", "update", "delete", "any"],
      contracts: ["create", "read", "update", "delete", "any"],
      importexcel: ["create", "read", "update", "delete", "any"],
      agencies: ["create", "read", "update", "delete", "any"],
      users: ["create", "read", "update", "delete", "any"],
      orders: ["create", "read", "update", "delete", "any"],
      tickets: ["create", "read", "update", "delete", "any"],
      stats: ["create", "read", "update", "delete", "any"],
      commissions: ["create", "read", "update", "delete", "any"],
      chatLogs: ["read"],
    },
    ADMINISTRATOR: {
      products: ["create", "read", "update", "delete", "any"],
      customers: ["create", "read", "update", "delete", "any"],
      families: ["create", "read", "update", "delete", "any"],
      contracts: ["create", "read", "update", "delete", "any"],
      importexcel: ["create", "read", "update", "delete", "any"],
      users: ["create", "read", "update", "delete", "any"],
      tickets: ["create", "read", "update", "delete", "any"],
      commissions: ["create", "read", "update", "delete", "any"],
      chatLogs: ["read"],
    },
    AGENCY_ADMIN: {
      products: ["create", "read", "update", "delete", "any"],
      customers: ["create", "read", "update", "delete"],
      contracts: ["create", "read", "update", "delete"],
      importexcel: ["create", "read", "update", "delete", "any"],
      users: ["create", "read", "update", "delete", "any"],
      commissions: ["create", "read", "update", "delete", "any"],
    },
    AGENCY: {
      products: ["create", "read", "update", "delete", "any"],
      customers: ["create", "read", "update", "delete"],
      contracts: ["create", "read", "update", "delete"],
      importexcel: ["create", "read", "update", "delete", "any"],
      users: ["create", "read", "update", "delete", "any"],
      commissions: ["create", "read", "update", "delete", "any"],
    },
    CAPO_AREA: {
      products: ["create", "read", "update", "delete", "any"],
      customers: ["create", "read", "update", "delete"],
      contracts: ["create", "read", "update", "delete"],
      users: ["create", "read", "update", "delete", "any"],
      commissions: ["create", "read", "update", "delete", "any"],
    },
    GROUP_MANAGER: {
      products: ["create", "read", "update", "delete", "any"],
      customers: ["create", "read", "update", "delete"],
      contracts: ["create", "read", "update", "delete"],
      users: ["create", "read", "update", "delete", "any"],
      commissions: ["create", "read", "update", "delete", "any"],
    },
    AGENT: {
      products: ["create", "read", "update", "delete"],
      customers: ["create", "read", "update", "delete"],
      contracts: ["create", "read", "update", "delete"],
      commissions: ["create", "read", "update", "delete", "any"],
    },
    JUNIOR_AGENT: {
      products: ["create", "read", "update", "delete"],
      customers: ["create", "read", "update", "delete"],
      contracts: ["create", "read", "update", "delete"],
      commissions: ["create", "read", "update", "delete", "any"],
    },
    CUSTOMER: {
      products: ["create", "read", "update", "delete", "any"],
      contracts: ["create", "read", "update", "delete", "any"],
      tickets: ["create", "read", "update", "delete", "any"],
    },
  },
  regex: {
    validString: /.{1,}/,
    validNumber:
      /^\+?\d{2,4}?[-.\/\\\s]?\(?\d{1,3}?\)?[-.\/\\\s]?\d{1,4}[-.\/\\\s]?\d{1,4}[-.\/\\\s]?\d{1,9}$/,
    email:
      /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
    password:
      /^(?=(.*[a-z]){1,})(?=(.*[A-Z]){1,})(?=(.*[0-9]){1,})(?=(.*[!@#$%^&*()-__+.]){1,}).{8,}$/,
    year: /^\d{4}$/g,
    postalCode: /^\d{5}$/,
    piva: /^[0-9]{11}$/,
    phone: { it: /^[0|3]{1}[0-9]{5,10}$/ },
    fiscalCode:
      /^([A-Za-z]{6}[0-9]{2}[A-Za-z][0-9]{2}[A-Za-z][0-9]{3}[A-Za-z])$/,
    iban: /^(it|IT)[0-9]{2}[A-Za-z][0-9]{10}[0-9A-Za-z]{12}$/,
  },
  apis,
  start: new Date().toISOString(),
};

export default { ...Config, ...publicConfig, ...env_config() };
